import { useCallback } from "react";
import { useTracking } from "@squareup/service-event-tracking";
import client from "./error-tracking-client.js";
import { useCashAppDefaultBrand } from "./useCashAppDefaultBrand.js";
const useCashAppLocalTracking = () => {
  const cdp = useTracking();
  const { data: brandData } = useCashAppDefaultBrand();
  const trackEvent = useCallback((feature, event, activity, params = {}) => {
    try {
      const trackingParams = { ...params };
      if (brandData?.brandToken) {
        trackingParams.brand_token = brandData.brandToken;
      }
      if (brandData?.locationConfigurations) {
        trackingParams.num_locations = brandData.locationConfigurations.length.toString();
      }
      const properties = {
        feature,
        activity,
        event,
        params: trackingParams
      };
      cdp.track(feature, properties);
    } catch {
      client.captureException(new Error("CDP tracking error"));
    }
  }, [cdp, brandData]);
  return {
    trackEvent
  };
};
export {
  useCashAppLocalTracking
};
//# sourceMappingURL=useCashAppLocalTracking.js.map
